import C2201Const from './C2201Const'

export default C2201Const.getStore()
